export default "__VITE_ASSET__DePDOKq4__"